import { REACT_TO_COMMENT_REQUEST, REACT_TO_COMMENT_FAILURE, REACT_TO_COMMENT_SUCCESS, } from './comments-reaction-actions';
import { unreachable } from '../../../../ts-utils';
import { hiddenComponentEffectsGuard } from '../effects/hidden-component-effects-guard';
import { resolveNextReactionData } from './comment-reaction-utils';
export function commentsReactionReducer(state, action) {
    switch (action.type) {
        case REACT_TO_COMMENT_REQUEST: {
            const { commentId, subaction, reactionCode } = action.payload;
            const commentState = state.commentsById[commentId];
            if (!('reactions' in commentState)) {
                return state;
            }
            const reactionState = commentState.reactions;
            if (reactionState?.type === 'PENDING') {
                return state;
            }
            return {
                ...state,
                commentsById: {
                    ...state.commentsById,
                    [commentId]: {
                        ...commentState,
                        reactions: {
                            ...commentState.reactions,
                            type: 'PENDING',
                            action: subaction,
                            reactionCode: subaction === 'REMOVE' ? undefined : reactionCode,
                        },
                    },
                },
            };
        }
        case REACT_TO_COMMENT_FAILURE: {
            const { commentId, error } = action.payload;
            const commentState = state.commentsById[commentId];
            if (!('reactions' in commentState)) {
                return state;
            }
            const reactionState = commentState.reactions;
            if (reactionState?.type !== 'PENDING') {
                return state;
            }
            return {
                ...state,
                commentsById: {
                    ...state.commentsById,
                    [commentId]: {
                        ...commentState,
                        reactions: { ...commentState.reactions, type: 'IDLE' },
                    },
                },
                ...hiddenComponentEffectsGuard(state, {
                    highlight: { type: 'CRUD_ERROR', id: commentId, timestamp: Date.now() },
                    toast: error.type === 'SILENT'
                        ? state.effects?.toast
                        : { skin: 'error', message: error, timestamp: Date.now() },
                }),
            };
        }
        case REACT_TO_COMMENT_SUCCESS: {
            const { commentId } = action.payload;
            const commentState = state.commentsById[commentId];
            if (!('reactions' in commentState)) {
                return state;
            }
            const reactionState = commentState.reactions;
            if (reactionState?.type !== 'PENDING') {
                return state;
            }
            return {
                ...state,
                commentsById: {
                    ...state.commentsById,
                    [commentId]: {
                        ...commentState,
                        reactions: {
                            type: 'IDLE',
                            ...resolveNextReactionData({
                                state: reactionState,
                                initiatorIdentity: action.payload.initiatorIdentity,
                            }),
                        },
                    },
                },
            };
        }
        default:
            throw unreachable(action);
    }
}
//# sourceMappingURL=comments-reaction-reducer.js.map